import React from "react";
import {makeImageUrlWithSize} from "../../../layouts/Home/HomeElements/utils";
import "./index.css"
import Video from "../../../assets/img/Letflow/SmartSearch/video.jpeg";
import AudioImage from "../../../assets/img/Letflow/SmartSearch/audio.png";
import Pdf from "../../../assets/img/Letflow/SmartSearch/pdf.jpeg";
import NoImage from "../../../assets/img/no_image.png";
import Delete from "@material-ui/icons/Delete";
import {ReactComponent as Star} from "../../../components/Letflow/SvgIcons/star.svg"
import Profile from "@material-ui/icons/AccountCircle";
import {homePathGenerator} from "../../../api-client/core/authentication/utils";
import browserHistory from "../../../utils/browserHistory";
import {Share} from "@material-ui/icons";
import { Tooltip } from "@material-ui/core";
import localization from "../../../config/localization";

const getImage = creation => {
  if (creation.image) {
    return makeImageUrlWithSize(creation, 'md-16:9');
  } else if (creation.video && creation.video.thumbnail) {
    return makeImageUrlWithSize({image: creation.video.thumbnail}, 'md-16:9');
  }

  return getNoImage(creation)
}

const getNoImage = (creation) => {
  if (!!creation.video) {
    return Video;
  }else if (!!creation.audio) {
    return AudioImage;
  }else if (!!creation.binary) {
    return Pdf;
  }else {
    return NoImage;
  }
}

const PlaylistCreationItem = ({creation, creator, onClick, onDelete, onFavorite, onShare, isPublic = false}) => {
  return (
    <div className="playlist-creation" onClick={onClick}>
      <div className="playlist-creation-item">
        <div className="playlist-creation-item-title"
             style={{color: "white"}}>{creation.title}</div>
        <div className="playlist-creation-item-image"
             style={{backgroundImage: `url(${getImage(creation)})`}}/>
        <div className="playlist-creation-item-fade">
          <div className="playlist-creation-item-icons">
            {onDelete && !isPublic && 
              <Tooltip placement="bottom" title={localization.get("remove_from_playlist")}>
                <Delete onClick={e => {
                  e.stopPropagation();
                  e.preventDefault();
                  onDelete()
                }}/>
              </Tooltip>
            }
            <Tooltip placement="bottom" title={localization.get("playlist.see_profile")}>
              <Profile onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                browserHistory.push(homePathGenerator(isPublic ? `bl/${creator.profile_url ? creator.profile_url : creator.hashcode}` : `contenido/${creator.id}-${creator.name}`))
              }}/>
            </Tooltip>
            {!isPublic &&
              <Tooltip placement="bottom" title={localization.get(creation.favorite ? "soundbar.remove_from_favorites" : "soundbar.add_to_favorites")}>
                <Star
                  className={`playlist-creation-over-actions-item ${creation.favorite ? "playlist-creation-over-actions-item-active" : ""}`}
                  style={{fontSize: 30, width: 22,height: 22,fill: "white"}}
                  onClick={e => {
                    e.stopPropagation();
                    e.preventDefault();
                    onFavorite(creation)
                  }}
                />
              </Tooltip>
            }
            {onShare && <Tooltip placement="bottom" title={localization.get("share")}><Share onClick={onShare}/></Tooltip>}
          </div>
        </div>
      </div>
    </div>
  )
}
export default PlaylistCreationItem